import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loginUser } from "../store/authentication/actions";
import Loading from "../components/shared/loader";
import { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { ReactComponent as ArrowLeftIcon } from "assets/svgs/arrow-left.svg";
import { ReactComponent as EmailIcon } from "assets/svgs/email-2.svg";
import { ReactComponent as PassIcon } from "assets/svgs/password.svg";
import { ReactComponent as TogglePassIcon } from "assets/svgs/view-toggle.svg";
import "styles/login.css";

function Login({ logo }) {
    const dispatch = useDispatch();
    const { loading, error } = useSelector((state) => state.authentication);
    const navigate = useNavigate();
    const { formatMessage } = useIntl();
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (error) {
            toast(error, { toastId: error });
        }
    }, [error]);

    const handleShowPassword = (e) => {
        e.preventDefault();

        setShowPassword((prevShowPassword) => {
            return !prevShowPassword;
        });
    };

    const { register, handleSubmit } = useForm();

    const onSubmit = (data) => {
        data.roleGroup = "partners";
        dispatch(loginUser({ data, navigate }));
    };
    if (loading) return <Loading />;

    return (
        <>
            <section className="register_page__">
                <div className="register_page_from_section__">
                    <Link className="go_back_home__" to={"/"}>
                        <figure className="shape__">
                            <ArrowLeftIcon />
                        </figure>
                        <FormattedMessage id="backHome" />
                    </Link>
                    <h2 className="register_head__">
                        <FormattedMessage id="login" />
                    </h2>
                    <form
                        className="register_form_content__"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <div className="login_input_group__">
                            <figure className="shape__">
                                <EmailIcon />
                            </figure>

                            <input
                                {...register("email")}
                                className="input__"
                                placeholder={formatMessage({ id: "email" })}
                            />
                        </div>
                        <div className="login_input_group__">
                            <figure className="shape__">
                                <PassIcon />
                            </figure>

                            <input
                                type={showPassword ? "text" : "password"}
                                {...register("password")}
                                className="input__"
                                placeholder={formatMessage({ id: "password" })}
                            />

                            <button
                                onClick={handleShowPassword}
                                className={`toggle_show_password_ ${
                                    showPassword ? "active__" : ""
                                }`}
                            >
                                <TogglePassIcon />
                            </button>
                        </div>

                        <div className="rember_me_wrapper__">
                            <label className="register_agree_policies__">
                                <span className="checkbox_group__">
                                    <input type="checkbox" />
                                    <span className="checkbox_label"></span>
                                </span>
                                <span className="text__">
                                    <FormattedMessage id="rememberMe" />
                                </span>
                            </label>

                            <Link
                                className="forgot_password_link__"
                                to={"/forgot-password"}
                            >
                                <FormattedMessage id="didYouForgotPassword" />
                            </Link>
                        </div>
                        <div className="register_submit_button_wrapper__">
                            <input
                                type="submit"
                                className="submit__  "
                                value={formatMessage({ id: "login" })}
                            />
                        </div>
                        {
                            // <FormLoader />
                        }
                    </form>
                </div>

                <div className="register_page_logo_section__">
                    <div className="register_logo__">
                        <Link to={"/"}>
                            <img src={logo} alt="" />
                        </Link>
                    </div>

                    <div className="register_info_content__">
                        <h2 className="head__">
                            <FormattedMessage id="welcomeBack" />
                        </h2>
                        <p className="parg__">
                            <FormattedMessage id="ToStayInTouchWithUsYourPersonalInformation" />
                        </p>
                        <Link className="create_store__" to="/register">
                            <FormattedMessage id="registerNewAccount" />
                        </Link>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Login;
